import { render, staticRenderFns } from "./HappinessReports.vue?vue&type=template&id=35cc4077&"
import script from "./HappinessReports.vue?vue&type=script&lang=js&"
export * from "./HappinessReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports